import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { RootState } from "redux/rootReducer";
import { Spin } from "antd";
import { useState } from "react";
import SmsDonationPopup from "components/smsDonation/SmsDonationPopup";
import RecentProjectCard from "./RecentProjectCard";

const RecentProjects = () => {
  const { t, i18n } = useTranslation();
  const { campaignListLoading, campaignList } = useSelector(
    (state: RootState) => state.campaignListReducer
  );

  const [showSmsDonation, setShowSmsDonation] = useState<boolean[]>(
    new Array(campaignList?.length).fill(false)
  );

  const handleSmsDonationToggle = (index: number) => {
    setShowSmsDonation((prev) => {
      const newState = [...prev];
      newState[index] = !newState[index];
      return newState;
    });
  };

  const { requestSecureUrlLoading } = useSelector(
    (state: RootState) => state.requestSecureUrlReducer
  );

  return (
    <section className="mainContainer w-full">
      {/* main header  ****************************/}
      <div
        className={`mt-[40px] flex items-center justify-center text-second_color text-[32px] font-${
          i18n.language === "en" ? "Poppins" : "Almarai"
        } font-[600]`}
      >
        <p>{t("Our Recent Projects")}</p>
      </div>

      {/* projects card section  ******************/}
      <Spin spinning={campaignListLoading}>
        <Splide
          options={{
            direction: `${
              localStorage.getItem("dir") === "rtl" ? "rtl" : "ltr"
            }`,
            grag: "free",
            arrows: true,
            pagination: false,
            width: "100%",
            autoplay: true,
            rewind: true,
            perMove: 1,
            easing: "ease-out",
            speed: 1000,
            interval: 3000,
            pauseOnHover: false,
            pauseOnFocus: true,
            breakpoints: {
              8560: { perPage: 3, gap: "20px" },
              4560: { perPage: 3, gap: "20px" },
              2560: { perPage: 3, gap: "20px" },
              1920: { perPage: 3, gap: "20px" },
              1600: { perPage: 3, gap: "20px" },
              1200: { perPage: 2, gap: "20px" },
              800: { perPage: 1, gap: "20px" },
            },
          }}
          className="px-[30px] lg:px-0 flex flex-wrap items-center justify-center gap-[20px] 2xl:gap-[60px]"
        >
          {campaignList?.map((project: any, i: number) => {
            return (
              <SplideSlide
                key={i}
                className="w-full flex items-center justify-center"
              >
                <RecentProjectCard
                  project={project}
                  showSmsDonation={showSmsDonation[i]}
                  setShowSmsDonation={() => handleSmsDonationToggle(i)}
                  requestSecureUrlLoading={requestSecureUrlLoading}
                />
              </SplideSlide>
            );
          })}
        </Splide>
      </Spin>

      {campaignList?.map((project: any, i: number) => {
        return (
          <div key={i}>
            {showSmsDonation[i] && (
              <SmsDonationPopup
                project={campaignList?.at(i)}
                show={showSmsDonation?.at(i) ?? false}
                setShow={() => handleSmsDonationToggle(i)}
              />
            )}
          </div>
        );
      })}
    </section>
  );
};

export default RecentProjects;
